import { postJSON, getJSON, getCSRFHeaders } from '@folklore/fetch';
import { stringify as stringifyQuery } from 'query-string';
import { generatePath } from 'react-router';

class Base {
    constructor(opts = {}) {
        this.options = {
            routes: {},
            getOptions: {},
            postOptions: {},
            putOptions: {},
            ...opts,
            baseUrl: opts.baseUrl || 'https://cuecue.io/api',
        };
    }

    requestGet(path, query = null) {
        const { getOptions } = this.options;
        const queryString =
            query !== null ? stringifyQuery(query, { arrayFormat: 'bracket' }) : null;
        return getJSON(
            `${this.getFullUrl(path)}${
                queryString !== null && queryString.length > 0 ? `?${queryString}` : ''
            }`,
            {
                ...getOptions,
                headers: getCSRFHeaders(),
            },
        );
    }

    requestPost(path, data) {
        const { postOptions } = this.options;
        return postJSON(this.getFullUrl(path), data, {
            ...postOptions,
            headers: getCSRFHeaders(),
        });
    }

    requestPut(path, data) {
        const { putOptions } = this.options;
        return postJSON(
            this.getFullUrl(path),
            {
                _method: 'PUT',
                ...data,
            },
            {
                ...putOptions,
                headers: getCSRFHeaders(),
            },
        );
    }

    requestDelete(path) {
        return this.requestPost(path, {
            _method: 'DELETE',
        });
    }

    route(route, params) {
        const { routes } = this.options;
        return generatePath(routes[route] || route, params);
    }

    getFullUrl(path) {
        const { baseUrl } = this.options;
        return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    }
}

export default Base;
